import React, { FC } from 'react';
import { Redirect } from 'react-router-dom';
import { Container } from '../../components/base/grid';
import Breadcrumbs from '../../components/breadcrumbs';
import SplitHero from '../../components/hero/splitHero';
import IContentSiteViewModel from '../../interfaces/umbracoNodes/contentSiteViewModel';
import { ContentSectionsMapper } from './contentSectionsMapper';
import * as StyledContentSite from './contentSite.styles';

interface Props {
	page: IContentSiteViewModel;
}

const ContentSiteFragment: FC<Props> = ({ page }) => {
	if (page.Values && page.Values.CustomInternalRedirect) {
		return <Redirect to={page.Values.CustomInternalRedirect.Url} />;
	}

	const { HeroImage, HeroTitle, HeroSubtitle, HeroContent, HeroButton, HeroBulletPoints } = page.Values;

	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />
			{HeroImage && (HeroSubtitle?.length > 0 || HeroContent?.length > 0) && (
				<SplitHero
					pageId={page.Id}
					title={HeroTitle || page.Name}
					subTitle={HeroSubtitle || ''}
					content={HeroContent || ''}
					button={HeroButton}
					image={HeroImage}
					heroBulletPoints={HeroBulletPoints}
				/>
			)}
			{page.Values.ContentSections &&
				page.Values.ContentSections.length > 0 &&
				page.Values.ContentSections.map((item, index) => (
					<StyledContentSite.ContentSectionWrapper key={index}>
						{ContentSectionsMapper(item)}
					</StyledContentSite.ContentSectionWrapper>
				))}
		</Container>
	);
};

export default ContentSiteFragment;
